export default {
  zh: {
    panel: {
      edit: '编辑',
      new: '添加',
    },
  },
  en: {
    panel: {
      edit: 'Edit ',
      new: 'Add New ',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/PrimaryDetails/i18n.js